import React from "react";

function ApprovedIconGreen() {
  return (
    <svg
      width="15"
      height="16"
      viewBox="0 0 15 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 8C0 3.58182 3.35795 0 7.5 0C11.642 0 15 3.58182 15 8C15 12.4182 11.642 16 7.5 16C3.35795 16 0 12.4182 0 8ZM7.5 14.5455C6.69416 14.5455 5.89621 14.3762 5.15172 14.0472C4.40722 13.7183 3.73075 13.2361 3.16094 12.6283C2.59112 12.0205 2.13912 11.299 1.83074 10.5048C1.52236 9.71071 1.36364 8.85956 1.36364 8C1.36364 7.14044 1.52236 6.28929 1.83074 5.49516C2.13912 4.70103 2.59112 3.97947 3.16094 3.37166C3.73075 2.76386 4.40722 2.28173 5.15172 1.95279C5.89621 1.62385 6.69416 1.45455 7.5 1.45455C9.12747 1.45455 10.6883 2.14415 11.8391 3.37166C12.9899 4.59918 13.6364 6.26404 13.6364 8C13.6364 9.73596 12.9899 11.4008 11.8391 12.6283C10.6883 13.8558 9.12747 14.5455 7.5 14.5455Z"
        fill="#39B260"
      />
      <g transform="translate(3.5, 4.5)">
        <path d="M2.89295 6.17236L0 3.08582L0.964091 2.05745L2.89295 4.11418L6.74932 0L7.71409 1.02909L2.89295 6.17236Z" fill="#39B260"/>
      </g>
    </svg>
  );
}

export default ApprovedIconGreen;
